<template>
    <div class="page-wrapper">
        <h2>Метрики за месяц</h2>
        <h-table
            :data="metricsDesc"
            row-key="name"
            :columns="metricsColumns"
            :loading="metricsLoading"
            :pagination.sync="metricsPagination"
            :rows-per-page-options='[10, 0]'
            ref="table"
            @request="fetchMetrics"
        >
            <q-tr slot="header" slot-scope="props" ref="thead">
                <h-th v-for="(col, index) in props.cols" :key="col.name" :props="props"
                      :class="{'loading': metricsLoading}">
                    {{ col.label }}
                </h-th>
            </q-tr>
        </h-table>
        <h2>Заказы</h2>
        <bar-chart :chart-data="chartData" :height="100" :width="300"></bar-chart>
    </div>

</template>

<script>
import _ from 'lodash'
import { BarChart, HTable, HTh } from 'components'
import { QTr } from 'quasar'

export default {
    name: 'Metrics',
    components: {
        HTable,
        HTh,
        BarChart,
        QTr,
    },
    data () {
        return {
            metrics: [],
            metricsDesc: [],
            metricsAsc: [],
            metricsColumns: [
                {
                    label: 'Дата',
                    field: 'DATE',
                    name: 'DATE',
                    sortable: true,
                    filter: '',
                    align: 'left',
                    type: 'text',
                },
                {
                    label: 'Заказы',
                    field: 'ORDERS_COUNT',
                    name: 'ORDERS_COUNT',
                    sortable: true,
                    filter: '',
                    align: 'left',
                    type: 'text',
                },
                {
                    label: 'Товары',
                    field: 'PRODUCTS_COUNT',
                    name: 'PRODUCTS_COUNT',
                    sortable: true,
                    filter: '',
                    align: 'left',
                    type: 'text',
                },
                {
                    label: 'Посетители',
                    field: 'VISITORS_COUNT',
                    name: 'VISITORS_COUNT',
                    sortable: true,
                    filter: '',
                    align: 'left',
                    type: 'text',
                },
            ],
            metricsLoading: false,
            metricsPagination: {
                page: 1,
                rowsPerPage: 10,
            },
            chartData: null,
        }
    },
    mounted () {
        this.fetchMetrics()
    },
    methods: {
        fetchMetrics () {
            this.metricsLoading = true
            this.$http.get(`api/v1.0/projects/${this.$route.params.id}/metrics`).then((response) => {
                let metricsByMonth = _.groupBy(response.data, row => row.created_at)

                _.forEach(metricsByMonth, (value, key) => {
                    let colsName = ['ORDERS_COUNT', 'PRODUCTS_COUNT', 'VISITORS_COUNT', 'MANAGERS_COUNT'],
                        data = {
                            'DATE': key,
                        }

                    _.forEach(colsName, (col) => {
                        if (value.find(obj => obj.type === col)) {
                            data[col] = value.find(obj => obj.type === col).count
                        } else {
                            data[col] = ''
                        }
                    })

                    this.metrics.push(data)
                    this.metricsLoading = false
                })

                this.metricsDesc = _.orderBy(this.metrics, 'DATE', 'desc')
                this.metricsAsc = _.orderBy(this.metrics, 'DATE', 'asc')

                this.chartData = {
                    labels: this.metricsAsc.map(val => {
                        return val.DATE
                    }),
                    datasets: [
                        {
                            label: 'Кол-во заказов',
                            backgroundColor: '#f87979',
                            data: this.metricsAsc.map(val => {
                                return val.ORDERS_COUNT
                            }),
                        },
                    ],
                }
            })
        },
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectMetricsView.vue